<template>
  <div class='authorized-table-cell'>
    <div class='authorized-table-cell__logos-row' v-if='passwordSprayRunning'>
      <div>
        <password-spray-logos class='authorized-table-cell__logos-row__logos' />
      </div>
      <div class='authorized-table-cell__logos-row__sprayer'>
        <span>
          <img class='authorized-table-cell__logos-row__sprayer__animated-logo' :src="require('@/assets/icons/pw-spray.webp')" />
        </span>
      </div>
    </div>
    <div v-else-if='hasSuccessLogins'>
      <span v-for='(logo, index) in logoList' :key='index' class='content'>
        <a v-if='logo.url.length>0' :href='getLogoUrl(logo.url)' target="_blank">
          <img v-if='isUserLeaked && logo.system' class='logo' :src="require(`@/assets/icons/systems/${logo.system}.svg`)" alt=""/>
        </a>
        <img v-if='isUserLeaked && logo.system && logo.url.length===0' class='logo' :src="require(`@/assets/icons/systems/${logo.system}.svg`)" alt=""/>
      </span>
    </div>
    <div class='authorized-table-cell__logos-row' v-else-if='passwordSprayWasRunning'>
      <div>
        <password-spray-logos class='authorized-table-cell__logos-row__logos' />
      </div>
    </div>
  </div>
</template>

<script>

import PasswordSprayLogos from '@/assets/icons/systems/pw_spray.svg?inline';

export default {
  name: 'AuthorizedTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  components: {
    PasswordSprayLogos,
  },
  computed: {
    logoDict() {
      return {
        aws: 'AWS',
        atlassian: 'Atlassian',
        checkpoint: 'CheckPoint',
        ews: 'EWS',
        fortivpn: 'FortiVPN',
        github: 'Github',
        gitlab: 'Gitlab',
        google: 'Google',
        joomla: 'Joomla',
        msol: 'MSOnline',
        o365: 'Office365',
        okta: 'Okta',
        owa: 'OWA',
        wordpress: 'Wordpress',
      };
    },
    logoList() {
      const tempLogoList = [];
      if (this.item?.authorized) {
        this.item.authorized.forEach(system => {
          tempLogoList.push({
            system: this.logoDict[system],
            url: Object.keys(this.item.platformUrls).length > 0 ? this.item?.platformUrls[system] || '' : '',
          });
        });
      }
      return tempLogoList;
    },
    isUserLeaked() {
      return this.item.password?.length;
    },
    hasSuccessLogins() {
      return this.logoList.length;
    },
    passwordSprayRunning() {
      return this.item?.passwordSprayRunning || false;
    },
    passwordSprayWasRunning() {
      return this.item?.passwordSprayWasRunning || false;
    },
  },
  methods: {
    getLogoUrl(url) {
      return Array.isArray(url) ? url[0] : url;
    },
  },
};
</script>

<style lang='scss' scoped>
.authorized-table-cell {
  .logo {
    width: 24px;
    height: 24px;
    margin-right: 3%;
    display: inline-block;
    margin-top: 17px;
  }
  &__logos-row{
    display: flex;
    align-items: center;
    &__sprayer{
      max-height: 50px;
      &__animated-logo{
        height: 50px;
        margin-top: -4px;
      }
    }
    &__logos {
      margin-top: 18px;
      height: 18px;
      opacity: 0.4;
    }
  }
}
</style>
